module.exports = __webpack_public_path__ + "img/SKLB-Mi Cuenta.2c1b277f.png";